import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import App from '../App';
import ErrorBoundary from '../components/ErrorBoundary';
import lazyWithRetry from '../utils/lazyWithRetry';

// Lazy-loaded page components with retry logic to handle stale chunk errors after deployments
const HomePage = lazyWithRetry(() => import('../pages/HomePage'));
const LineDetailsPage = lazyWithRetry(() => import('../pages/LineDetailsPage'));
const LandingPage = lazyWithRetry(() => import('../pages/LandingPage'));
const DynamicLandingPage = lazyWithRetry(() => import('../pages/DynamicLandingPage'));
const UnauthorizedPage = lazyWithRetry(() => import('../pages/UnauthorizedPage'));
const OmniversePage = lazyWithRetry(() => import('../pages/OmniversePage'));

// Suspense fallback for route transitions
const RouteFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <CircularProgress />
  </Box>
);
// Define routes with lazy-loaded page components
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Suspense fallback={<RouteFallback />}><HomePage /></Suspense>,
      },
      {
        path: '/dashboard',
        element: <Suspense fallback={<RouteFallback />}><LandingPage /></Suspense>,
      },
      {
        path: '/home',
        element: <Suspense fallback={<RouteFallback />}><DynamicLandingPage /></Suspense>,
      },
      {
        path: '/omniverse',
        element: <Suspense fallback={<RouteFallback />}><OmniversePage /></Suspense>,
      },
      {
        path: '/line/:lineNumber',
        element: <Suspense fallback={<RouteFallback />}><LineDetailsPage /></Suspense>,
      },
      {
        path: '/unauthorized',
        element: <Suspense fallback={<RouteFallback />}><UnauthorizedPage /></Suspense>,
      },
    ],
  },
]);

const AppRouter = () => {
  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
};

export default AppRouter;